import React from "react";
import { Link } from "react-router-dom";
import { Home } from "lucide-react";

export default function NotFoundPage() {
  return (
    <main data-testid="page-not-found" className="relative pt-40 pb-24 min-h-[70vh] flex items-center">
      <div className="absolute inset-0 bg-grid opacity-30 [mask-image:radial-gradient(ellipse_at_center,black_30%,transparent_70%)]" />
      <div className="relative max-w-3xl mx-auto px-6 text-center">
        <div className="text-7xl md:text-9xl font-display font-bold text-gradient-blue">404</div>
        <h1 className="mt-4 font-display text-3xl md:text-4xl font-semibold text-white">Page introuvable</h1>
        <p className="mt-3 text-slate-400">La page que vous cherchez n'existe pas ou a été déplacée.</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-8 rounded-full bg-blue-500 hover:bg-blue-400 text-white font-medium px-6 py-3 glow-blue transition-all"
        >
          <Home size={16} /> Retour à l'accueil
        </Link>
      </div>
    </main>
  );
}
